import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useScope } from '../../../contexts/scopeContext';
import { useAuth } from '../../../contexts/authContext';
import { colors } from '../../../theme';
import { RouterUrlParams } from '../../../App';

const UserDashboardSectionLink = () => {
	const { acceptedApplicationsData } = useScope();
	const { currentUser } = useAuth();
	const { organizationName, programName } = useParams() as RouterUrlParams;
	const location = useLocation();
	const { t } = useTranslation();

	const isMainProgramPage = location.pathname === `/${organizationName}/${programName}`;
	if (!currentUser || !isMainProgramPage || !acceptedApplicationsData.length) {
		return null;
	}

	return (
		<div className="lp-custom-module lp-custom-module-text">
			<div className="landing-page-container py-4 mb-4">
				<div className="lp_header_wrapper">
					<div className="lp_header_main">{t('landingPages.userAreaTitle')}</div>
					<div className="lp_header_sub">
						<p>{t('landingPages.userAreaSubtitle')}</p>
					</div>
				</div>
				<div className="lp_intro_inner">
					<div className="lp_intro_box">
						<div className="lp_intro_text">
							<p>{t('landingPages.userAreaDescription')}</p>
							<h3>
								<span style={{ fontSize: '24px' }}>
									<strong>
										<ins>
											<Link
												to={`/panel/${organizationName}/${programName}`}
												className="font-bold underline p-0 text-xl"
											>
												{t('landingPages.userAreaLink')}
											</Link>
										</ins>
									</strong>
								</span>
							</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserDashboardSectionLink;
